import { LoginInput } from '@/model/user/LoginInput';
import Http from '../http';
import SSOAuthCenterHttp from '../ssoAuthCenterHttp';

//单系统登录
export const login = function (loginForm: LoginInput) {
  return Http.post('/api/OpenApi/Login', loginForm)
}

//sso统一登录接口
export const ssoLogin = function (loginForm: any) {
    return SSOAuthCenterHttp.post('/api/SSOAuthCenter/Login', loginForm)
}

//检查授权状态
export const checkAuthState = function () {
    return SSOAuthCenterHttp.get('/api/SSOAuthCenter/CheckAuthState')
}


//获取公司下系统的菜单
export const getMenuByUserId = async  function () {
    return  Http.get('/api/OpenApi/GetMenuByUserId');
 }

 //获取所有公司-select结构，登录使用
 export const getCorporationSelect = async function() {
    return await Http.get('/api/OpenApi/GetCorporation');
 }
 